/* smartMart added: make Flits "THE WINE WAS ADDED TO THE CART" banner clickable */
document.addEventListener('click', function (e) {
  let closestFlitsSnackbarContainer =
    e.target.closest(`.flits-snackbar-container.${window.pnk?.getAlpineData('snackbarClasses')?.addToCart || 'add-to-cart'}`)
  if (closestFlitsSnackbarContainer) {
    // slideout banner to hide, close ajax Product card, open ajax Cart card
    document.querySelector('#ajax-product-body button.close').dispatchEvent(new Event('click')) ;
    document.querySelector('button#item_count').dispatchEvent(new Event('click'));
    closestFlitsSnackbarContainer.style.bottom = '-100px';
    console.debug('Flits "...ADDED TO THE CART" banner: Cart opened');     
  }
});
console.debug('Flits "...ADDED TO THE CART" banner: make clickable done');